import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;

const sid = () => {
  let s = localStorage.getItem("dm_sid");
  if (!s) {
    s = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random().toString(16).slice(2);
    localStorage.setItem("dm_sid", s);
  }
  return s;
};

export const api = axios.create({ baseURL: `${BACKEND}/api` });
api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("dm_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  cfg.headers["X-Session-Id"] = sid();
  return cfg;
});

export const imgUrl = (p) => (!p ? null : p.startsWith("http") ? p : `${BACKEND}/api/files/${p}`);

export const track = (type, data = {}) => api.post("/events", { type, ...data }).catch(() => {});

const compress = (file) => new Promise((resolve) => {
  const img = new Image();
  img.onload = () => {
    const scale = Math.min(1, 1600 / Math.max(img.width, img.height));
    const c = document.createElement("canvas");
    c.width = Math.round(img.width * scale);
    c.height = Math.round(img.height * scale);
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    c.toBlob((b) => resolve(b || file), "image/jpeg", 0.82);
    URL.revokeObjectURL(img.src);
  };
  img.onerror = () => resolve(file);
  img.src = URL.createObjectURL(file);
});

export const uploadImage = async (file) => {
  const blob = await compress(file);
  const fd = new FormData();
  fd.append("file", blob, "photo.jpg");
  const { data } = await api.post("/uploads", fd);
  return data.path;
};

const readList = (k) => { try { return JSON.parse(localStorage.getItem(k) || "[]"); } catch { return []; } };
export const getSaved = () => readList("dm_saved");
export const toggleSaved = (id) => {
  const list = getSaved();
  const next = list.includes(id) ? list.filter((x) => x !== id) : [id, ...list];
  localStorage.setItem("dm_saved", JSON.stringify(next));
  const on = next.includes(id);
  if (localStorage.getItem("dm_token")) (on ? api.post(`/saves/${id}`) : api.delete(`/saves/${id}`)).catch(() => {});
  return on;
};
export const syncSaved = (push) => api.post("/saves/sync", { ids: push ? getSaved() : [] })
  .then((r) => localStorage.setItem("dm_saved", JSON.stringify(r.data.ids))).catch(() => {});
export const getRecent = () => readList("dm_recent");
export const pushRecent = (p) => {
  const item = { id: p.id, title: p.title, type: p.type, photo: p.photos?.[0] || null, price: p.price, contact_for_price: p.contact_for_price, category_id: p.category_id };
  const next = [item, ...getRecent().filter((x) => x.id !== p.id)].slice(0, 10);
  localStorage.setItem("dm_recent", JSON.stringify(next));
};

const CANON = (process.env.REACT_APP_PUBLIC_URL || "").replace(/\/$/, "");
const isPreview = () => /(\.preview\.emergentagent\.com|localhost|127\.0\.0\.1)$/.test(window.location.hostname);
export const siteUrl = () => (CANON && !isPreview() ? CANON : window.location.origin);
export const redirectToCanonical = () => {
  if (!CANON || isPreview()) return false;
  const canonHost = new URL(CANON).hostname;
  const h = window.location.hostname;
  if (h === canonHost || h.endsWith(".emergent.host")) return false;
  window.location.replace(CANON + window.location.pathname + window.location.search + window.location.hash);
  return true;
};
